package io.horion.cv.models

import androidx.compose.runtime.Composable
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.modifiers.color
import com.varabyte.kobweb.silk.components.icons.fa.FaBolt
import com.varabyte.kobweb.silk.components.icons.fa.FaBriefcase
import com.varabyte.kobweb.silk.components.icons.fa.FaBuilding
import com.varabyte.kobweb.silk.components.icons.fa.FaBullhorn
import com.varabyte.kobweb.silk.components.icons.fa.FaCar
import com.varabyte.kobweb.silk.components.icons.fa.FaChartLine
import com.varabyte.kobweb.silk.components.icons.fa.FaFileContract
import com.varabyte.kobweb.silk.components.icons.fa.FaFileLines
import com.varabyte.kobweb.silk.components.icons.fa.FaGavel
import com.varabyte.kobweb.silk.components.icons.fa.FaGraduationCap
import com.varabyte.kobweb.silk.components.icons.fa.FaHammer
import com.varabyte.kobweb.silk.components.icons.fa.FaHospital
import com.varabyte.kobweb.silk.components.icons.fa.FaHotel
import com.varabyte.kobweb.silk.components.icons.fa.FaHouse
import com.varabyte.kobweb.silk.components.icons.fa.FaIndustry
import com.varabyte.kobweb.silk.components.icons.fa.FaLaptopCode
import com.varabyte.kobweb.silk.components.icons.fa.FaLeaf
import com.varabyte.kobweb.silk.components.icons.fa.FaMoneyBill
import com.varabyte.kobweb.silk.components.icons.fa.FaMountain
import com.varabyte.kobweb.silk.components.icons.fa.FaPalette
import com.varabyte.kobweb.silk.components.icons.fa.FaRoad
import com.varabyte.kobweb.silk.components.icons.fa.FaSeedling
import com.varabyte.kobweb.silk.components.icons.fa.FaShield
import com.varabyte.kobweb.silk.components.icons.fa.FaShirt
import com.varabyte.kobweb.silk.components.icons.fa.FaStore
import com.varabyte.kobweb.silk.components.icons.fa.FaTruck
import com.varabyte.kobweb.silk.components.icons.fa.FaUser
import com.varabyte.kobweb.silk.components.icons.fa.FaUtensils
import com.varabyte.kobweb.silk.components.icons.fa.FaWifi
import com.varabyte.kobweb.silk.components.icons.fa.IconSize
import io.horion.cv.utils.Colors


object DomaineActivite {

    val domaineList = mapOf(

        "Domaine Santé" to "Sanitaire",
        "Informatique" to "Développement logiciel, réseau, cybersécurité",
        "Travaux Bâtiment" to "Construction et rénovation de bâtiments",
        "Travaux Publics" to "Routes, ponts et infrastructures publiques",
        "Finance" to "Banque, comptabilité et gestion financière",
        "Gestion" to "Administration et management d'enterprise",
        "Secrétariat" to "Assistance administrative et bureautique",
        "Commerce" to "Vente, distribution et relation client",
        "Marketing" to "Communication et stratégie commerciale",
        "Ressources Humaines" to "Gestion du personnel et recrutement",
        "Éducation" to "Enseignement et formation",
        "Transport et Logistique" to "Gestion des transports et livraisons",
        "Agriculture" to "Production agricole et élevage",
        "Énergie" to "Électricité, solaire et énergies renouvelables",
        "Télécommunication" to "Réseaux télécom et communication",
        "Hôtellerie" to "Hébergement et accueil",
        "Restauration" to "Cuisine et services alimentaires",
        "Juridique" to "Droit et assistance juridique",
        "Architecture" to "Conception de bâtiments et urbanisme",
        "Infographie et Design" to "Création graphique et multimédia",
        "Maintenance Industrielle" to "Réparation et entretien technique",
        "Mécanique Automobile" to "Entretien et réparation de véhicules",
        "Sécurité" to "Surveillance et protection",
        "Immobilier" to "Gestion et vente de biens immobiliers",
        "Audit et Conseil" to "Analyse et accompagnement des entreprises",
        "Assurance" to "Gestion des contrats et risques",
        "Industrie" to "Production industrielle et usine",
        "Mines et Carrières" to "Exploitation minière",
        "Environnement" to "Protection et gestion environnementale",
        "Mode et Couture" to "Stylisme et confection textile",
        "Artisanat" to "Fabrication artisanale et métiers manuels"
    )
}

fun getDomaineIcon(domaine: String): @Composable () -> Unit {
    return when (domaine) {

        "Domaine Santé", "Santé" -> {
            { FaHospital(size = IconSize.XL, modifier = Modifier.color(Colors.Blue)) }
        }

        "Informatique" -> {
            { FaLaptopCode(size = IconSize.XL, modifier = Modifier.color(Colors.Blue)) }
        }

        "Travaux Bâtiment" -> {
            { FaBuilding(size = IconSize.XL, modifier = Modifier.color(Colors.Blue)) }
        }

        "Travaux Publics" -> {
            { FaRoad(size = IconSize.XL, modifier = Modifier.color(Colors.Blue)) }
        }

        "Finance" -> {
            { FaMoneyBill(size = IconSize.XL, modifier = Modifier.color(Colors.Blue)) }
        }

        "Gestion" -> {
            { FaBriefcase(size = IconSize.XL, modifier = Modifier.color(Colors.Blue)) }
        }

        "Secrétariat" -> {
            { FaFileLines(size = IconSize.XL, modifier = Modifier.color(Colors.Blue)) }
        }

        "Commerce" -> {
            { FaStore(size = IconSize.XL, modifier = Modifier.color(Colors.Blue)) }
        }

        "Marketing" -> {
            { FaBullhorn(size = IconSize.XL, modifier = Modifier.color(Colors.Blue)) }
        }

        "Ressources Humaines" -> {
            { FaUser(size = IconSize.XL, modifier = Modifier.color(Colors.Blue)) }
        }

        "Éducation" -> {
            { FaGraduationCap(size = IconSize.XL, modifier = Modifier.color(Colors.Blue)) }
        }

        "Transport et Logistique" -> {
            { FaTruck(size = IconSize.XL, modifier = Modifier.color(Colors.Blue)) }
        }

        "Agriculture" -> {
            { FaSeedling(size = IconSize.XL, modifier = Modifier.color(Colors.Blue)) }
        }

        "Énergie" -> {
            { FaBolt(size = IconSize.XL, modifier = Modifier.color(Colors.Blue)) }
        }

        "Télécommunication" -> {
            { FaWifi(size = IconSize.XL, modifier = Modifier.color(Colors.Blue)) }
        }

        "Hôtellerie" -> {
            { FaHotel(size = IconSize.XL, modifier = Modifier.color(Colors.Blue)) }
        }

        "Restauration" -> {
            { FaUtensils(size = IconSize.XL, modifier = Modifier.color(Colors.Blue)) }
        }

        "Juridique" -> {
            { FaGavel(size = IconSize.XL, modifier = Modifier.color(Colors.Blue)) }
        }

        "Architecture" -> {
            { FaBuilding(size = IconSize.XL, modifier = Modifier.color(Colors.Blue)) }
        }

        "Infographie et Design" -> {
            { FaPalette(size = IconSize.XL, modifier = Modifier.color(Colors.Blue)) }
        }

        "Industrie", "Maintenance Industrielle" -> {
            { FaIndustry(size = IconSize.XL, modifier = Modifier.color(Colors.Blue)) }
        }

        "Mécanique Automobile" -> {
            { FaCar(size = IconSize.XL, modifier = Modifier.color(Colors.Blue)) }
        }

        "Sécurité" -> {
            { FaShield(size = IconSize.XL, modifier = Modifier.color(Colors.Blue)) }
        }

        "Immobilier" -> {
            { FaHouse(size = IconSize.XL, modifier = Modifier.color(Colors.Blue)) }
        }

        "Audit et Conseil" -> {
            { FaChartLine(size = IconSize.XL, modifier = Modifier.color(Colors.Blue)) }
        }

        "Assurance" -> {
            { FaFileContract(size = IconSize.XL, modifier = Modifier.color(Colors.Blue)) }
        }

        "Mines et Carrières" -> {
            { FaMountain(size = IconSize.XL, modifier = Modifier.color(Colors.Blue)) }
        }

        "Environnement" -> {
            { FaLeaf(size = IconSize.XL, modifier = Modifier.color(Colors.Blue)) }
        }

        "Mode et Couture" -> {
            { FaShirt(size = IconSize.XL, modifier = Modifier.color(Colors.Blue)) }
        }

        "Artisanat" -> {
            { FaHammer(size = IconSize.XL, modifier = Modifier.color(Colors.Blue)) }
        }

        else -> {
            { FaBriefcase(size = IconSize.XL, modifier = Modifier.color(Colors.Blue)) }
        }
    }
}